<h3>
    <i ng-show="item.isProtected" class="fa fa-lock" style="color: gray"></i>
    <a ng-click="viewDetails($event, item)">
        {{ item.name }}<span ng-if="!item.isActive"> {{'centuriList.inactive'|translate}}</span>
    </a>
</h3>